import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import NavigationBar from './NavigationBar';
import ComposeEmail from './ComposeEmail';
import StripeOnboardingBanner from './StripeOnboardingBanner';
import MfaEnrollmentModal from './MfaEnrollmentModal';
import FloatingActionButton from './FloatingActionButton';
import CreateOptionsModal from './CreateOptionsModal';
import InvoiceModal from './InvoiceModal';
import AgreementModal from './AgreementModal';
import MobileTopBar from './MobileTopBar';
import ChatInputBar from './klo/ChatInputBar';
import { EmailProvider } from '../contexts/EmailContext';
import { AuthProvider } from '../contexts/AuthContext';
import { StripeProvider } from '../contexts/StripeContext';
import { auth } from '../firebase';
import { MfaContext } from '../App';

const AppLayout = () => {
  const user = auth.currentUser;
  const [showComposeModal, setShowComposeModal] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showMfaModal, setShowMfaModal] = useState(false);
  const [showCreateOptions, setShowCreateOptions] = useState(false);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showAgreementModal, setShowAgreementModal] = useState(false);

  const handleMfaSuccess = () => {
    setShowMfaModal(false);
  };

  return (
    <AuthProvider currentUser={user}>
      <EmailProvider user={user}>
        <StripeProvider user={user}>
          <MfaContext.Provider value={{ showMfaModal, setShowMfaModal }}>
            <div className="flex h-screen bg-[#FAFAFA] dark:bg-[#0A0A0A] text-gray-900 dark:text-white overflow-hidden min-w-[280px]">
              <NavigationBar 
                setShowComposeModal={setShowComposeModal} 
                isMenuOpen={isMenuOpen}
                setIsMenuOpen={setIsMenuOpen}
              />

              {/* Main Content - Island Style */}
              <div
                className="flex-1 flex flex-col min-w-[280px] py-2 pr-2"
                onClick={() => isMenuOpen && setIsMenuOpen(false)}
              >
                {/* Mobile Top Bar */}
                <div className="lg:hidden">
                  <MobileTopBar
                    onMenuToggle={() => setIsMenuOpen(!isMenuOpen)}
                    user={user}
                  />
                </div>

                {/* Main Content Area - Floating Island */}
                <div className="flex-1 overflow-hidden bg-white dark:bg-[#111111] rounded-2xl relative">
                  <Outlet />
                  {/* Global Chat Input - covers full area for overlay, input at bottom */}
                  <div className="absolute inset-0 z-30 pointer-events-none flex flex-col justify-end">
                    <div className="pointer-events-auto">
                      <ChatInputBar />
                    </div>
                  </div>
                </div>
              </div>

              {/* Modals */}
              <ComposeEmail
                isOpen={showComposeModal}
                onClose={() => setShowComposeModal(false)}
                user={user}
              />

              {/* MFA Enrollment Modal - globally accessible */}
              <MfaEnrollmentModal
                isOpen={showMfaModal}
                user={user}
                onSuccess={handleMfaSuccess}
                onClose={() => setShowMfaModal(false)}
              />

              {/* Floating Action Button - Mobile only */}
              <FloatingActionButton 
                onClick={() => setShowCreateOptions(true)}
              />

              {/* Create Options Modal */}
              <CreateOptionsModal
                isOpen={showCreateOptions}
                onClose={() => setShowCreateOptions(false)}
                onCreateEmail={() => {
                  setShowCreateOptions(false);
                  setShowComposeModal(true);
                }}
                onCreateInvoice={() => {
                  setShowCreateOptions(false);
                  setShowInvoiceModal(true);
                }}
                onCreateAgreement={() => {
                  setShowCreateOptions(false);
                  setShowAgreementModal(true);
                }}
              />

              {/* Invoice Modal */}
              <InvoiceModal
                isOpen={showInvoiceModal}
                onClose={() => setShowInvoiceModal(false)}
                user={user}
              />

              {/* Agreement Modal */}
              <AgreementModal
                isOpen={showAgreementModal}
                onClose={() => setShowAgreementModal(false)}
              />

              {/* Stripe Onboarding Banner */}
              <StripeOnboardingBanner />
            </div>
          </MfaContext.Provider>
        </StripeProvider>
      </EmailProvider>
    </AuthProvider>
  );
};

export default AppLayout;
